import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const PropositionBetsDetailsModuleAsyncComponent = AsyncComponent(async () => import('./proposition-bets-details-module' /* webpackChunkName: "proposition-bets-details-module" */ ));

export const PropositionBetsDetailsModuleAsync = (props) => {
  return <React.Suspense fallback={<div/>}>
    <PropositionBetsDetailsModuleAsyncComponent {...props}/>
  </React.Suspense>
};
